import { ref, watch, computed } from '@vue/composition-api'
// import store from '@/store'
import axios from 'axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useCustomerOrders() {
  // Use toast
  const toast = useToast()

  const refCustomerOrdersTable = ref(null)

  // Table Handlers
  const tableColumns = [
    // { key: 'id', label: '#', sortable: true },
    { key: 'id', sortable: false },
    { key: 'invoice_id', sortable: false },
    { key: 'type', sortable: false },
    { key: 'created_at', sortable: false },
    { key: 'status', sortable: false },
    { key: 'paid', sortable: false },
    { key: 'total', sortable: false },
  ]
  const perPage = ref(15)
  const id = ref('')
  const orderType = ref(1)
  const totalCustomerOrders = ref(0)
  const currentPage = ref(1)
  const lastPage = ref(1)
  const perPageOptions = [15, 30, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refCustomerOrdersTable.value ? refCustomerOrdersTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCustomerOrders.value,
    }
  })

  const refetchData = () => {
    refCustomerOrdersTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, id, orderType], () => {
    refetchData()
  })

  const fetchCustomerOrders = (ctx, callback) => {
    axios
      .get(`${process.env.VUE_APP_BASE_API_URL}/userlaundryorders/${id.value}/${orderType.value}?paginate&page=${currentPage.value}&perPage=${perPage.value}`)
      .then(res => {
        const customerOrders = res.data.data.items
        totalCustomerOrders.value = res.data.data.total
        currentPage.value = res.data.data.current_page
        lastPage.value = res.data.data.last_page

        callback(customerOrders)
      }).catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching Customer Orders' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  return {
    fetchCustomerOrders,
    tableColumns,
    perPage,
    currentPage,
    lastPage,
    totalCustomerOrders,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refCustomerOrdersTable,
    id,
    orderType,

    refetchData,
  }
}
